import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { MessageCircle } from "lucide-react";

let cachedNumber = null;

const useWhatsApp = () => {
  const [number, setNumber] = useState(cachedNumber);
  useEffect(() => {
    if (cachedNumber) return;
    api.get("/contact").then(({ data }) => {
      cachedNumber = data.whatsapp_number;
      setNumber(cachedNumber);
    }).catch(() => {});
  }, []);
  return number;
};

const waLink = (number, text) => {
  const digits = (number || "").replace(/\D/g, "");
  return `https://wa.me/${digits}?text=${encodeURIComponent(text)}`;
};

/** Bouton inline (ex : fiche expédition, préremplit la référence). */
export const WhatsAppButton = ({ reference, className = "" }) => {
  const number = useWhatsApp();
  const { t } = useI18n();
  if (!number) return null;
  const text = reference ? t("wa.msgRef").replace("{ref}", reference) : t("wa.msg");
  return (
    <a href={waLink(number, text)} target="_blank" rel="noopener noreferrer" data-testid="whatsapp-btn"
      className={`flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebe5b] text-white font-semibold text-sm px-4 py-2.5 transition-colors ${className}`}>
      <MessageCircle className="h-4 w-4" /> {t("wa.cta")}
    </a>
  );
};

/** Bouton flottant global (toutes pages). */
export const WhatsAppFloat = () => {
  const number = useWhatsApp();
  const { t } = useI18n();
  if (!number) return null;
  return (
    <a href={waLink(number, t("wa.msg"))} target="_blank" rel="noopener noreferrer" data-testid="whatsapp-float"
      title={t("wa.cta")} aria-label="WhatsApp Colis2Go"
      className="fixed bottom-24 right-3 md:bottom-6 md:right-6 z-30 flex h-11 w-11 md:h-12 md:w-12 items-center justify-center rounded-full bg-[#25D366] hover:bg-[#1ebe5b] text-white shadow-lg transition-colors">
      <MessageCircle className="h-6 w-6" />
    </a>
  );
};
